module.exports = __webpack_public_path__ + "img/marker_need.f8d66ec0.png";